import { ChamberSelect, UsDistrictSelect, type UsFilters, UsStateSelect, UsTableFilters } from 'components'
import { FormControl, TextField } from '@mui/material'
import React from 'react'

interface MemberFilterProps {
  filters: UsFilters
  updateFilters: (filters: any) => void
  doFilter: () => Promise<void>
  cleanFilters: () => void
}

export const MemberFilters: React.FC<MemberFilterProps> = ({ filters, updateFilters, doFilter, cleanFilters }) => {
  return (
    <UsTableFilters doFilter={doFilter} filters={filters} updateFilters={updateFilters} cleanFilters={cleanFilters}>
      <FormControl variant="outlined" fullWidth={true}>
        <TextField
          label="First Name"
          value={filters.firstName ?? ''}
          onChange={(event) => { updateFilters({ firstName: event.target.value }) }}
          variant="outlined"
          fullWidth
        />
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <TextField
          label="Last Name"
          value={filters.lastName ?? ''}
          onChange={(event) => { updateFilters({ lastName: event.target.value }) }}
          variant="outlined"
          fullWidth
        />
      </FormControl>
     <FormControl variant="outlined" fullWidth={true}>
        <ChamberSelect updateChamber={(chamber) => { updateFilters({ chamber }) }} value={filters.chamber} disabled={false}/>
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <UsStateSelect value={filters.state} updateState={(state) => { updateFilters({ state }) }} onlyUSStates={true} disabled={false}/>
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <UsDistrictSelect value={filters.district} filters={filters} updateDistrict={(district) => { updateFilters({ district }) }} disabled={false}/>
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <TextField
          label="Email"
          value={filters.email ?? ''}
          onChange={(event) => { updateFilters({ email: event.target.value }) }}
          variant="outlined"
          fullWidth
        />
      </FormControl>
    </UsTableFilters>
  )
}
